export enum ProductCardMessages {
  quickViewOpenModalCapability = 'product discovery',
  quickViewModalName = 'product quick view',
  quickViewOpenModalEvent = 'modal open',
}
